/* eslint-disable no-console */
import React, { Component } from 'react';
import { func, node } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '@landtrustinc/design-system';

import css from './BookingChanges.module.css';

class BookingChangesErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('BookingChanges Error:', error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { onClose, children } = this.props;

    if (hasError) {
      return (
        <div className={css.root}>
          <div className={css.errorContainer}>
            <div className={css.errorContent}>
              <p className={css.errorMessage}>
                <FormattedMessage id="BookingChanges.errorMessage" />
              </p>
              <Button
                onClick={() => {
                  this.setState({ hasError: false });
                  if (onClose) onClose();
                }}
              >
                <FormattedMessage id="BookingChanges.errorButton" />
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return children;
  }
}

BookingChangesErrorBoundary.defaultProps = {
  onClose: null,
};

BookingChangesErrorBoundary.propTypes = {
  children: node.isRequired,
  onClose: func,
};

export default BookingChangesErrorBoundary;
